
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import editar from './editar-pedido.vue';
    import { Utiles, utf8_to_b64, b64_to_utf8 } from '@/__env/pluggins/event-bus';
    import { Vendedor } from '@/__env/lib/Ventas/Vendedores';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Pago } from '@/__env/lib/Ventas/Pagos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { isObject, isArray, isString } from 'util';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { ImportarPedidoDesdeExcel } from '@/__env/lib/Ventas/Pedidos/ImportarDesdeExcel';
    import { create } from 'domain';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar,
        }

    } )
    export default class Componente extends Vue
    {
        public Controlador: ControladorInterfaz = null;
        public get Estado() { return this.Controlador.Vista.Estado; }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        async created()
        {
            this.Controlador = new ControladorInterfaz();
            //console.log( this.$route.query.d );
            this.Controlador.EdicionPedido.Modo = 'plataformas';
            this.Controlador.Vista.Estado = 'cargando';

            this.Controlador.Vista.BarraDebajo.Altura.Espacio = 70;
            this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
            this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = 400;
            this.Eventos.push( this.Controlador.EdicionPedido.onTipo.subscribe( () => this.onCambios() ) );

            if ( this.$route.params.id )
            {
                this.Controlador.Iniciar( parseInt( this.$route.params.id ) );
            }
            else if ( this.$route.query.d && isString( this.$route.query.d ) )
            {
                try
                {
                    let js64 = b64_to_utf8( this.$route.query.d );
                    let js = JSON.parse( js64 );
                    if ( isObject( js ) && isArray( js.datos ) )
                    {
                        let pedidos: Pedido[] = [];
                        for ( let data of js.datos )
                        {
                            let pp = await ImportarPedidoDesdeExcel( data, Pedidos.Tipos.toTipo( js.tipo ) );
                            if ( pp )
                            {
                                let pedOrig = pedidos.find( x => x.IdExterna && x.Tipo.Id == pp.Tipo.Id && x.IdExterna == pp.IdExterna );
                                if ( pedOrig )
                                {
                                    pedOrig.Items.push( ...pp.Items );

                                    pedOrig.Envio.Importes.Base += pp.Envio.Importes.Base;
                                    pedOrig.Envio.Importes.Propio += pp.Envio.Importes.Propio;
                                    pedOrig.Envio.Importes.Cliente += pp.Envio.Importes.Cliente;

                                    pedOrig.Pagos[0].Importes.Pagado += pp.Pagos[0].Importes.Pagado;
                                    pedOrig.Pagos[0].Comision.Monto += pp.Pagos[0].Comision.Monto;
                                    pedOrig.Pagos[0].CostoFinanciero.Monto += pp.Pagos[0].CostoFinanciero.Monto;
                                    pedOrig.Pagos[0].CargoPorEnvio += pp.Envio.Importes.Cliente;
                                    pedOrig.Pagos[0].Comision.Porcentaje = ( pedOrig.Pagos[0].Comision.Monto / pedOrig.Pagos[0].Importes.Pagado );
                                    pedOrig.Pagos[0].CostoFinanciero.Porcentaje = ( pedOrig.Pagos[0].CostoFinanciero.Monto / pedOrig.Pagos[0].Importes.Pagado );

                                } else
                                {
                                    pedidos.push( pp );
                                }

                            }
                        }
                        if ( pedidos.hasRows() )
                        {
                            console.log( pedidos[0] );
                            this.Controlador.Iniciar( pedidos );
                            return;
                        }

                    }
                    this.Controlador.Iniciar();
                } catch ( e )
                {
                    this.Controlador.Iniciar();
                }
            } else
            {
                this.Controlador.Iniciar();
            }


        }


        async onCambios()
        {

            if ( this.Controlador.EdicionPedido.Tipo && !this.Controlador.EdicionPedido.Tipo.esNoEspecificado )
            {
                this.Controlador.EdicionPedido.Modo = 'plataformas';
                if ( this.Controlador.EdicionPedido.Tipo.VendedorPredeterminado )
                    this.Controlador.EdicionPedido.Vendedor = await Vendedor.create( this.Controlador.EdicionPedido.Tipo.VendedorPredeterminado );

                if ( this.Controlador.EdicionPedido.Tipo.ClientePredeterminado )
                    this.Controlador.EdicionPedido.Cliente = await Cliente.create( this.Controlador.EdicionPedido.Tipo.ClientePredeterminado );
                else
                    this.Controlador.EdicionPedido.Cliente = new Cliente();

                this.Controlador.EdicionPedido.Envio = new Envio();
                this.Controlador.EdicionPedido.Envio.Tipo = this.Controlador.EdicionPedido.Tipo.TipoEnvioPredeterminado;
                if ( !this.Controlador.EdicionPedido.Tipo.TipoEnvioPredeterminado.esNoEspecificado && !this.Controlador.EdicionPedido.Tipo.TipoEnvioPredeterminado.esRetiraCliente )
                {
                    this.Controlador.EdicionPedido.Envio.EmpresaLogistica = await Transporte.create( '001' );
                }

                this.Controlador.EdicionPedido.Pagos.clear();
                let p = new Pago();
                this.Controlador.EdicionPedido.Pagos.push( p );
            }
        }



    }
